import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Popup } from 'semantic-ui-react';
import { GetContactAccountSuggestionCounts } from '../../graphql/accountSuggestions';
import {
  openAccountSuggestionsPanel,
  subscribeAccountSuggestionsChanged,
} from '../../utils/accountSuggestionsPanel';
import './AiOpportunitiesDropdown.scss';

/**
 * Botón en el header: abre el panel de sugerencias (modal Pascale) sin cambiar de página.
 */
const AiOpportunitiesDropdown = ({ companyId }) => {
  const { t } = useTranslation('header');
  const { data, reexecuteQuery } = GetContactAccountSuggestionCounts(companyId);

  useEffect(() => {
    return subscribeAccountSuggestionsChanged(() => {
      if (!companyId) return;
      reexecuteQuery({ requestPolicy: 'network-only' });
    });
  }, [companyId, reexecuteQuery]);

  const counts = data?.contactAccountSuggestionCounts || { providers: 0, clients: 0, total: 0 };
  const total = counts.total || 0;

  return (
    <div className="ai-opportunities-dropdown">
      <Popup
        content={t('opportunities.tooltip')}
        inverted
        size="small"
        position="bottom center"
        mouseEnterDelay={200}
        trigger={
          <button
            type="button"
            className="aiHeaderButton aiHeaderButton--iconOnly aiOpportunitiesButton"
            aria-label={t('opportunities.label')}
            onClick={() => openAccountSuggestionsPanel()}
          >
            <span className="aiHeaderButton__icon aiOpportunitiesButton__icon" aria-hidden>
              <Icon name="magic" />
            </span>
            {total > 0 && (
              <span className="aiOpportunitiesButton__badge">{total > 99 ? '99+' : total}</span>
            )}
          </button>
        }
      />
    </div>
  );
};

export default AiOpportunitiesDropdown;
